import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Truck, ArrowRight, Package } from "lucide-react";
import { useAuth } from "../context/AuthContext";
import { subscribeDriverJobs } from "../lib/deliveries";

export default function DriverDeliveries() {
  const { user } = useAuth();
  const [jobs, setJobs] = useState([]);
  useEffect(() => {
    if (!user) return;
    const unsub = subscribeDriverJobs(user.email, setJobs);
    return () => unsub && unsub();
  }, [user]);

  return (
    <div className="bg-slate-50 min-h-screen">
      <section className="bg-[#0f2847] text-white stripe-bg">
        <div className="container-518 py-8">
          <div className="text-[11px] uppercase tracking-[0.22em] font-bold text-[#f59321] mb-1">Driver · My routes</div>
          <h1 className="font-display text-2xl md:text-3xl font-extrabold flex items-center gap-3"><Truck className="w-7 h-7 text-[#f59321]" /> Assigned deliveries</h1>
        </div>
      </section>
      <section className="container-518 py-8 space-y-4 max-w-2xl" data-testid="driver-jobs">
        {jobs.length === 0 ? (
          <div className="bg-white rounded-2xl border border-slate-200 p-12 text-center">
            <Package className="w-12 h-12 text-slate-300 mx-auto mb-4" />
            <p className="text-slate-500">No routes assigned to you yet. Ask dispatch to assign a job to <span className="font-semibold">{user?.email}</span>.</p>
          </div>
        ) : jobs.map((j) => (
          <Link key={j.id} to={`/driver/deliveries/${j.id}`} data-testid={`driver-job-${j.id}`} className="block bg-white rounded-2xl border border-slate-200 p-6 card-lift">
            <div className="text-xs font-bold text-[#f59321]">{j.job_reference}</div>
            <h3 className="font-display font-extrabold text-[#0f2847] text-lg">{j.job_name}</h3>
            <div className="text-sm text-slate-500 mt-0.5">{j.job_date} · Pickup: {j.pickup_address}</div>
            <div className="mt-4 flex items-center gap-3">
              <div className="flex-1 h-2 bg-slate-100 rounded-full overflow-hidden"><div className="h-full bg-[#f59321] rounded-full" style={{ width: `${j.total_stops ? (j.completed_stops / j.total_stops) * 100 : 0}%` }} /></div>
              <span className="text-sm font-bold text-[#0f2847]">{j.completed_stops || 0} / {j.total_stops || 0}</span>
              <ArrowRight className="w-5 h-5 text-[#f59321]" />
            </div>
          </Link>
        ))}
      </section>
    </div>
  );
}
